import React from 'react';
import {Text, Button, Icon, Heading} from '@albert-io/atomic';

export const ContentBlocker = () => {
  return (
    <div className='question-content-blocker u-mar-t_4'>
      <div className='question-content-blocker__icon-wrapper'>
        <Icon icon='lock' className='question-content-blocker__lock-icon' size='inherit' />
      </div>
      <div className='question-content-blocker__description u-mar-t_2'>
        <Heading size='l'>Unlock the answer with a license!</Heading>
        <Text size='l' as='ul' bold color='inherit' className='u-mar-tb_2'>
          <li>Interactive questions</li>
          <li>Detailed explanations & how others answered</li>
          <li>Standards alignment</li>
        </Text>
      </div>
      <div className='u-mar-t_6'>
        <Button as='a' href='/pricing-schools' className='view-license-options'>
          <Icon icon='sparkles' className='u-mar-r_1' />
          <Text>View License Options</Text>
        </Button>
      </div>
      <Icon icon='sparkles' className='question-content-blocker__icon--sparkles' />
    </div>
  );
};
